import { Modal, Button, Typography, Spin, Row, Col, Divider } from "antd";
import { IoCloseOutline } from "react-icons/io5";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { channelController } from "../../controllers/channelController";
import axios from "../../utils/axios";
import { useSelector } from "react-redux";
import { useMQTT } from "../../context/MqttContext";
const { Text, Title } = Typography;

const AMC = ({ responsedata, setresponsedata, open, setopen }) => {
  const { mqttEvents } = useMQTT();
  const [loading, setLoading] = useState(false);
  const [name, setname] = useState("");
  const { sessionid, username } = useSelector((state) => state.userDetails);

  const { deviceid, status } = responsedata;

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        let res = await axios.post("/submeter/getchannelinfo", {
          username,
          channelid: deviceid,
        });
        let result = channelController(res);

        if (result.type !== "success") {
          toast[result.type](result.message);
          setLoading(false);
          return;
        }

        setname(result.message.body[0].devicealias);
        setLoading(false);
      } catch (err) {
        toast.error(err.message);
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Modal
      open={open}
      onCancel={() => {
        setresponsedata("");
        setopen(false);
      }}
      footer={null}
      centered
      width={400}
    >
      <Row justify="space-between" align="middle">
        <Col>
          <Title level={4}>Create Meter Class</Title>
        </Col>
        <Col>
          <IoCloseOutline
            size={24}
            style={{ cursor: "pointer" }}
            onClick={() => {
              setresponsedata("");
              setopen(false);
            }}
          />
        </Col>
      </Row>

      <Divider />

      <Row justify="center" style={{ paddingTop: "10px" }}>
        {status === "SUCCESS" ? (
          <Text type="success">Meter class issued to meter successfully</Text>
        ) : status === "failure@METER_CLASS_NOT_FOUND" ? (
          <Text type="danger">Meter class not found, please try again</Text>
        ) : status === "failure@INVALID_METER_ID" ? (
          <Text type="danger">Invalid meter ID passed</Text>
        ) : (
          <Text>{status}</Text>
        )}
      </Row>

      <Row justify="center" style={{ padding: "15px 0" }}>
        {/* <div
          style={{
            width: 60,
            height: 60,
            borderRadius: "50%",
            padding: 10,
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          }}
        >
          <img
            src={ConnectionImg}
            alt="Connection"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div> */}
      </Row>

      <Row justify="center">
        <Text>Meter Name:</Text>
      </Row>

      <Row justify="center">
        <Title level={5}>{loading ? <Spin /> : name}</Title>
      </Row>

      <Row justify="center" style={{ marginTop: 20 }}>
        <Button type="primary" onClick={() => setopen(false)}>
          Close
        </Button>
      </Row>
    </Modal>
  );
};

export default AMC;
